// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e48319b9","703":"41815507","787":"3ed9f16f"}[chunkId] + ".chunk.js";
};